import * as React from "react";
import { Icon } from "../../../../components/generic";
import * as M from "../../../../models";
import { DateHelper, ReactHelper, Utility } from "../../../../utils";

interface OwnProps {
    dragHandle: React.ComponentClass<{}>;
    isSearch: boolean;
    session: M.Event.SubEvent;
    onRsvpExportClick: (evtId: number) => void;
    onSessionAbstractClick: (abstractId: number) => void;
    onSessionDeleteClick: (session: M.Event.SubEvent) => void;
    onSessionEditClick: (session: M.Event.SubEvent) => void;
}

interface OwnState {
}

export class SessionComponent extends React.Component<OwnProps, OwnState> {
    public render() {
        const session = this.props.session;
        const a = session.scheduledAbstract;

        let abstractAuthors: JSX.Element | null = null;
        let title = <p className="schedule-event-title" dangerouslySetInnerHTML={{ __html: session.title }} />;
        let invitationResponse: M.Generic.TypeDefinition | undefined;
        let isAccepted = false;

        if (a) {
            // this session has a scheduled abstract
            abstractAuthors = a.primaryAuthors.length
                ? <>{Utility.joinSkipEmpty(a.primaryAuthors.map((x) => M.Generic.PersonHelper.getFullNameWithSuffix(x)), ", ")}</>
                : null;

            title = <p className="schedule-event-title">
                <a
                    href="#"
                    dangerouslySetInnerHTML={{ __html: a.title }}
                    onClick={(e) => { ReactHelper.emptyClick(e); this.props.onSessionAbstractClick(a.id); }}
                />
            </p>;

            if (a.invitationResponseId) {
                invitationResponse = M.Abstract.InvitationResponse.getResponse(a);
                isAccepted = M.Abstract.InvitationResponse.isAccepted(a);
            }
        }

        return <div className="schedule-event">
            {this.props.isSearch ? null : <this.props.dragHandle />}
            <div className="schedule-event-time" dangerouslySetInnerHTML={{
                __html: DateHelper.displayTimeRange(
                    Utility.fromApiDateAsMoment(session.startDate),
                    Utility.fromApiDateAsMoment(session.endDate),
                    "&ndash;",
                ),
            }}/>
            <div className={(this.props.isSearch ? "searched " : "") + "schedule-event-summary"}>
                {title}
                {a
                    ? <p>
                        {abstractAuthors}{" "}
                        {invitationResponse
                            ? <span className={"label label-" + (isAccepted ? "accepted" : "declined")}>{invitationResponse.name}</span>
                            : null}
                    </p>
                    : null}
                <ul className="schedule-event-details">
                    <li title={DateHelper.displayTimeDuration(session.duration, false)}>
                        {DateHelper.displayTimeDuration(session.duration, true)}
                    </li>
                    {session.type ? <li>{session.type}</li> : null}
                    {a
                        ? <li>
                            {a.typeShortName}{a.placement || a.classification ? " - " : ""}
                            {Utility.joinSkipEmpty([a.placement, a.classification], ", ")}
                        </li>
                        : null
                    }
                    {session.locationName ? <li>{session.locationName}</li> : null}
                    {session.canRsvp
                        ? <li>
                            <Icon icon="check" /> RSVP{" "}
                            {session.seatsLeft < (session.seatsAvailable || 0)
                                ? <span>(<a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.props.onRsvpExportClick(session.id); }}>
                                    {(session.seatsAvailable || 0) - session.seatsLeft} of {session.seatsAvailable}
                                </a>)</span>
                                : null}
                        </li>
                        : null}
                </ul>
            </div>
            <ul className="schedule-event-actions">
                <li>
                    <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.props.onSessionEditClick(session); }} title="Edit">
                        <Icon icon="pencil" />
                    </a>
                </li>
                <li>
                    <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.props.onSessionDeleteClick(session); }} title="Delete">
                        <Icon icon="trash" />
                    </a>
                </li>
            </ul>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminEvent/editCalendar/components/SessionComponent.tsx